import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Using backbone.js for fun and profit",
  "description": "",
  "published": "2011-06-17T00:00:00.000Z",
  "redirect_from": ["/blog/?p=1862"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Tukile bomo napisal kej o backbone.js, predvsem kako ga uporablam pa zakaj mi je tok awesome, da sem ga dodal v svoj boilerplate.`}</p>
    <p>{`Nasledn tedn, zdej se mi ne da vec pisat :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      